export default __webpack_public_path__ + "static/media/eqd.4b26d5ab.svg";